//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GenericModal from "@Shared/components/modals/generic-modal.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AccountPlanMessageModal",
  components: {
    GenericModal
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  methods: {
    show() {
      this.$showModal();
    },
    hide() {
      this.$hideModal();
    }
  }
});